import * as Yup from "yup";

const addLeaguesSchema = Yup.object().shape({
  league_name: Yup.string().required("Name is required"),
  description: Yup.string().required("Description is required"),
});

export default addLeaguesSchema;
